import { useTranslation } from "@coworker/locales";
import { NotificationString } from "./types/translated-strings.types";

interface NotificationStringItemProps {
  notificationString: NotificationString;
  className?: string;
}

export const NotificationStringItem = ({
  notificationString,
  className,
}: NotificationStringItemProps) => {
  const { t } = useTranslation();
  const { text, style } = notificationString;
  if (typeof text === "string") {
    return (
      <div className={className} style={style}>
        {text}
      </div>
    );
  } else {
    const { key, options } = text;
    return (
      <div className={className} style={style}>
        {t(key, options)}
      </div>
    );
  }
};
